<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ (serviceCategory.id) ? 'Edit Service Category' : 'Create Service Category' }}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button
        [hidden]="savingInProgress || isLoading"
        (click)="onServiceCategoryFormSave()">
        Done
      </ion-button>
      <ion-button icon-only *ngIf="savingInProgress || isLoading">
        <ion-spinner icon="crescent"></ion-spinner>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>
<ion-content>
  <form [formGroup]='serviceCategoryForm'>
    <ion-item lines="none">
      <ion-label position="stacked" class="ion-padding-bottom">Category Name</ion-label>
      <ion-input type="text" name='' formControlName="serviceCategory" class="smr-input-border" clearInput></ion-input>
    </ion-item>

    <ion-item *ngIf="!serviceCategoryField.valid && submitAttempt">
      <p *ngIf="serviceCategoryField.hasError('required')" class='sm-error'>
        Oops, a service category name is required.
      </p>
    </ion-item>

    <br/>
    <br/>

    <ion-button fill="clear" expand="block" color="danger" *ngIf='serviceCategory.id' (click)="onDeleteServiceCategory()">Delete</ion-button>
  </form>
</ion-content>